import { useEffect, useState } from 'react'

export function isI18nReady() {
  return typeof window.I18n !== 'undefined' && typeof window.I18n.t === 'function'
}

export function useI18nReady() {
  const [ready, setReady] = useState(isI18nReady)

  useEffect(() => {
    if (ready) return undefined

    const intervalId = window.setInterval(() => {
      if (isI18nReady()) {
        setReady(true)
        window.clearInterval(intervalId)
      }
    }, 50)

    return () => window.clearInterval(intervalId)
  }, [ready])

  return ready
}
